export default __webpack_public_path__ + "static/media/icon_input_image_upload.873c326b.png";